import { isDefined } from "@clipboard-health/util-ts";
import { type QueryClient } from "@tanstack/react-query";

import { get } from "../api";
import {
  type ClipboardScoreProfileResponse,
  clipboardScoreProfileResponseSchema,
  getClipboardScoreProfilePath,
} from "../ClipboardScore/api/useGetClipboardScoreProfile";
import { environmentConfig } from "../environment";

interface GetClipboardScoreProfileForLiveActivityParams {
  workerId: string;
  qualification: string;
  queryClient: QueryClient;
}

export async function getClipboardScoreProfileForLiveActivity(
  params: GetClipboardScoreProfileForLiveActivityParams
) {
  const { workerId, qualification, queryClient } = params;
  const clipboardScoreProfileUrl = getClipboardScoreProfilePath(workerId);
  const url = `${environmentConfig.REACT_APP_ATTENDANCE_SCORE_SERVICE_URL}${clipboardScoreProfileUrl}`;
  const queryParams = { qualification };
  const queryKey = [url, queryParams];

  let clipboardScoreProfileData = queryClient.getQueryData<ClipboardScoreProfileResponse>(queryKey);

  if (!isDefined(clipboardScoreProfileData)) {
    const response = await get({
      url,
      queryParams,
      responseSchema: clipboardScoreProfileResponseSchema,
    });
    clipboardScoreProfileData = response.data;
  }

  const onTimePointsReward = clipboardScoreProfileData?.policy?.shiftClockInConfig?.points;

  const latePointsDeduction = clipboardScoreProfileData?.policy?.latenessConfig?.sort(
    (a, b) => (a.minutesLateRange?.startFrom ?? 0) - (b.minutesLateRange?.startFrom ?? 0)
  )?.[0]?.points;

  return {
    onTimePointsReward,
    latePointsDeduction,
  };
}
